import {useGetTradeName} from '@/modules/products/trade-names/api'
import {useBatchContext} from '@/shared/contexts/batch'
import {Flex, Icon, Tabs} from '@chakra-ui/react'
import {DataList, DataListItem} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {getShortDateFormatter, getShortDateFormatterUTC} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'
import {LuInfo} from 'react-icons/lu'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {batch} = useBatchContext()
  const [tradeName] = useGetTradeName(batch.tradeNameId)

  const {about, note} = useMemo(() => {
    const about: DataListItem[] = [
      {
        label: 'GTIN',
        value: tradeName?.barcodeGtin || '-',
      },
      {
        label: t('national_id'),
        value: tradeName?.nationalId || '-',
      },
      {
        label: t('product_name'),
        value: tradeName?.name || '-',
      },
      {
        label: t('batch_number'),
        value: batch.lotNumber || '-',
      },
      {
        label: t('expiry_date'),
        value: batch.expiryDate ? getShortDateFormatterUTC().format(batch.expiryDate) : '-',
      },
      {
        label: t('supplier'),
        value: batch.supplierCompany?.name || '-',
      },
      {
        label: t('storage_location'),
        value: batch.stockLocation?.name || '-',
      },
      {
        label: t('remaining_quantity'),
        value: batch.quantity,
      },
      {
        label: t('initial_quantity'),
        value: batch.receivedQuantity,
      },
      {
        label: t('created_by'),
        value: batch.created?.displayUsername ? `@${batch.created?.displayUsername}` : '-',
      },
      {
        label: t('date'),
        value: batch.createdAt ? getShortDateFormatter().format(batch.createdAt) : '-',
      },
    ]
    const note = batch.note

    return {
      about,
      note,
    }
  }, [batch, tradeName, t])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DataSection label={t('about')}>
        <DataList items={about} />
      </DataSection>

      <DataSection label={t('note')}>
        <Flex gap={1} color="fg.muted" fontSize="sm">
          {note && <Icon as={LuInfo} size="sm" />}
          {note || '-'}
        </Flex>
      </DataSection>
    </Tabs.Content>
  )
}
